module.exports = require("core-js-pure/features/json/stringify");